import React, { useContext, useEffect, useState } from 'react';
import Loading from './components/loading/Loading';
import Axios from 'axios';
import { WrongParams, WrongSpecId, ServerError } from './components/ErrorPages/ErrorPages';
import { LinkContext } from './LinkContext';
import Home from './Home';
import { SpecInfo } from './types/SpecInfo';

const App: React.FC = () => {
  const context = useContext(LinkContext);
  const [specId, setSpecId] = useState(-1);
  const [specInfo, setSpecInfo] = useState<any>({});
  const [isLoadingInfo, setIsLoadingInfo] = useState(true);
  const [wrongSpecId, setWrongSpecId] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [profileID, setProfileID] = useState(-1);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    let specIdFromUrl = -1;

    for (const [param, value] of Array.from(searchParams.entries())) {
      if (param === 'direction_id') {
        specIdFromUrl = Number(value);
      }

      if (param === 'profile_id') {
        setProfileID(Number(value));
      }
    }

    Axios
      .get(`${context}/lk/api/directions/get/${specIdFromUrl}`)
      // .get(`http://127.0.0.1:8000/api/directions/get/${specIdFromUrl}`)
      .then((response) => {
        setSpecId(specIdFromUrl);
        setSpecInfo(response.data);
        setIsLoadingInfo(false);
        document.title = `РТУ МИРЭА - ${response.data.name ? response.data.name : ''}`;
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 500) {
          setWrongSpecId(true);
          setIsLoadingInfo(false);
        } else {
          setServerError(true);
          setIsLoadingInfo(false);
        }
      });
  }, [context]);

  if (serverError) {
    return <ServerError />;
  }

  if (specId === -1 && !isLoadingInfo) {
    return <WrongParams />;
  }

  if (wrongSpecId) {
    return <WrongSpecId />;
  }

  if (isLoadingInfo) {
    return <Loading />;
  }

  return <Home specInfo={specInfo} />;
};

export default App;
